export enum ReportingPeriods {
  Any = 'Any',
  Unknown = 'Unknown',
  BS1 = 'BS1',
  A = 'A',
  I1 = 'I1',
  I2 = 'I2',
  I3 = 'I3'
}
